import React, { FC } from 'react';
import { SelectProps } from 'antd';
import { Select } from '~/components';
import { useTranslation } from 'react-i18next';

const ManualScreeningResolutionSelect: FC<SelectProps<string>> = (props) => {
  const { t } = useTranslation('ksaReview');

  const options = [
    { label: t('Full match'), value: 'FULL_MATCH', key: 'FULL_MATCH' },
    { label: t('No matches'), value: 'NO_MATCHES', key: 'NO_MATCHES' },
    { label: t('Partial match'), value: 'PARTIAL_MATCH', key: 'PARTIAL_MATCH' },
  ];

  return <Select options={options} allowClear {...props} />;
};

export default ManualScreeningResolutionSelect;
